/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Booking_Title7Inputs */

const en_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appointment booking`)
};

const ar_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجز المواعيد`)
};

const bn_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপয়েন্টমেন্ট বুকিং`)
};

const de_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminbuchung`)
};

const es_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva de citas`)
};

const fr_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prise de rendez-vous`)
};

const pt_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendamento de consultas`)
};

const zh_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约预订`)
};

const tr_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Randevu alma`)
};

const ru_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись на приём`)
};

const pl_svc_ai_voice_agents_booking_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja wizyt`)
};

/**
* | output |
* | --- |
* | "Appointment booking" |
*
* @param {Svc_Ai_Voice_Agents_Booking_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_booking_title7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Booking_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Booking_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_booking_title7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_booking_title7(inputs)
	return en_svc_ai_voice_agents_booking_title7(inputs)
});
export { svc_ai_voice_agents_booking_title7 as "svc_ai-voice-agents_BOOKING_title" }